/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creator_Checkout_Verification_Failed_TitleInputs */

const en_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification Failed`)
};

const fr_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification echouee`)
};

const de_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Überprüfung fehlgeschlagen`)
};

const it_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica fallita`)
};

const ru_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверка не удалась`)
};

const es_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación fallida`)
};

const zh_cn2_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证失败`)
};

const ja_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検証に失敗しました`)
};

const hi_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सत्यापन में विफल रहा`)
};

const pt_pt2_creator_checkout_verification_failed_title = /** @type {(inputs: Creator_Checkout_Verification_Failed_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificação falhou`)
};

/**
* | output |
* | --- |
* | "Verification Failed" |
*
* @param {Creator_Checkout_Verification_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const creator_checkout_verification_failed_title = /** @type {((inputs?: Creator_Checkout_Verification_Failed_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creator_Checkout_Verification_Failed_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_creator_checkout_verification_failed_title(inputs)
	if (locale === "de") return de_creator_checkout_verification_failed_title(inputs)
	if (locale === "it") return it_creator_checkout_verification_failed_title(inputs)
	if (locale === "ru") return ru_creator_checkout_verification_failed_title(inputs)
	if (locale === "es") return es_creator_checkout_verification_failed_title(inputs)
	if (locale === "zh-CN") return zh_cn2_creator_checkout_verification_failed_title(inputs)
	if (locale === "ja") return ja_creator_checkout_verification_failed_title(inputs)
	if (locale === "hi") return hi_creator_checkout_verification_failed_title(inputs)
	if (locale === "pt-PT") return pt_pt2_creator_checkout_verification_failed_title(inputs)
	return en_creator_checkout_verification_failed_title(inputs)
});